"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const memberNumberChecksum = (number) => {
    const sum = (0, lodash_1.default)(number)
        .initial()
        .map((digit, index) => digit * (index + 1))
        .sum();
    const expectedCheckDigit = sum % 11;
    const actualCheckDigit = lodash_1.default.toInteger(lodash_1.default.last(number));
    return expectedCheckDigit === actualCheckDigit || (expectedCheckDigit === 10 && actualCheckDigit === 0);
};
exports.default = memberNumberChecksum;
